import { combineReducers, Reducer } from 'redux';
import { RouterState } from 'redux-first-history';

import { adminReducer } from '../components/admin/store/reducer';
import { annexReducer } from '../components/agency-annex/store/reducer';
import { userAttestationReducer } from '../components/attestations/store/reducer';
import { authReducer } from '../components/auth/store/reducer';
import { clauseLibraryReducer } from '../components/clause-library/store/reducer';
import { datasetInstanceReducer } from '../components/datasets/instances/store/reducer';
import { pdfReducer } from '../components/documents/document-viewer/store/reducer';
import { documentReducer } from '../components/documents/store/reducer';
import { doraReducer } from '../components/dora/store/reducer';
import { homepageReducer } from '../components/home/store/reducer';
import { navigationReducer } from '../components/navigation/store/reducer';
import { opinionReducer } from '../components/opinions/store/reducer';
import { userPlaybookReducer } from '../components/playbook/store/reducer';

export const createRootReducer = (routerReducer: Reducer<RouterState>) => combineReducers({
    router: routerReducer,
    auth: authReducer,
    admin: adminReducer,
    datasetInstance: datasetInstanceReducer,
    navigation: navigationReducer,
    document: documentReducer,
    annexDefinition: annexReducer,
    opinion: opinionReducer,
    attestations: userAttestationReducer,
    homepage: homepageReducer,
    playbook: userPlaybookReducer,
    clauseLibrary: clauseLibraryReducer,
    dora: doraReducer,
    pdf: pdfReducer
});
